import StorageService from "service/storage";
import http from "service/api";
import { Api } from "settings";
import { isSuccessResponse } from "../../../shared";
import { fromServer } from "./home.mappers";
import { UtilConst } from "settings/data";

export const fetchOffersAction = (payload) => ({
  type: "FETCH_OFFERS",
  payload,
});

export const fetchOffers = () => {
  return async (dispatch, getState) => {
    try {
      const referral_code = StorageService.getItem(UtilConst.ls_referral_code);     
      let apiUrl = Api.getOffersEndPoint;
      if (referral_code) {
        apiUrl += `?referral=${referral_code}`;
      }
      const response = await http.get(apiUrl, { target: "alf" });
      const data = response.data.result;

      if (isSuccessResponse(response)) {
        return dispatch(
          fetchOffersAction({
            promotions: fromServer(data.promotions),
            referralDiscount: data.referral_discount,
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
};
